"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RecommendationsRepository {
    fetcherAmplify;
    constructor(fetcherAmplify) {
        this.fetcherAmplify = fetcherAmplify;
    }
    async getRecommendedFunds({ customerId, riskProfile, targetDate, }) {
        const response = await this.fetcherAmplify.get(`/v1/customers/${customerId}/recommendations/funds`, {
            queryStringParameters: {
                riskProfile,
                targetDate,
            },
        });
        return response;
    }
    async getRecommendedSeries(params) {
        const response = await this.fetcherAmplify.get(`/v1/customers/${params.customer.id}/recommendations/series`, {
            queryStringParameters: {
                fundId: params.fundId,
                amount: params.amount,
                currency: params.currency,
                customerType: params.customer.type,
            },
        });
        return response;
    }
}
exports.default = RecommendationsRepository;
//# sourceMappingURL=RecommendationsRepositoryImpl.js.map